import React from 'react'
import ReactDOM from 'react-dom/client'

import './index.css'

import { HelmetProvider } from '@dr.pogodin/react-helmet'
import { pdfjs } from 'react-pdf'

import App from '@app/App'

import '@app/i18n'

import { Loading } from '@shared/components/Loading/Loading'

import reportWebVitals from './reportWebVitals'

if (!pdfjs?.version) {
  throw new Error('pdfjs version does not exist')
}

// CDN for everything on npm
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<Loading isLoading showLoadingIcon />}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.Suspense>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
